import "./style.css";
const ShowComment = ({ eachComment }) => {
  return (
    <div className="show-comment-box bg-shiri p-4 flex-column w-50 mb-4">
      <p className="mb-2">
        {eachComment.f_name} <span>{eachComment.l_name}</span>{" "}
      </p>
      <p className="m-0 text-justify">{eachComment.message}</p>
    </div>
  );
};

export default ShowComment;
